<template>
  <div class="app-container">
    <van-nav-bar title="上传票据" :right-text="ym" left-arrow
                 @click-left="$router.push('/home')"
                 @click-right="showDate = true"
    />
    <my-company />
    <van-row>
      <van-col :span="24">
        <van-cell v-for="type in CONST.FILE_TYPE_LIST" :key="type.id" :title="type.name"
                  :icon="folderIcon" :to="`upload/${type.id}`" is-link />
      </van-col>
    </van-row>
    <change-ym :show="showDate" @change="onYmChange" />
        <van-popup v-model="showTip" position="bottom" :close-on-click-overlay="false" :style="{ padding:'2rem 0' }">
      <van-col span="20" offset='2'>重要声明</van-col>
      <van-col span="20" offset='2' style="text-align: left">
        1. 上传票据者（下文简称：用户），有义务遵守国家相关法律法规规定，保证所传票据为真实、有效、合规、合法票据；
        <br />
        2. 用户应在当月记账征期开始1周内上传完成所有票据，留出充足时间记账、报税；
        <br />
        3. 在未提供给北京春雪会计服务有限公司（下文简称：春雪公司）原始票据前，用户承担所有上传票据对应的原始纸质票据保存义务；
        <br />
        4. 春雪公司使用客户上传的所有电子票据作为依据完成记账、报税等工作；
        <br />
        5. 由于票据合法性原因、延期提交票据原因、原始纸质票据丢失原因等造成的账务问题的情况，春雪公司不承担相应责任；
        <br />
        6. 继续使用本功能，表示您接受并认可此声明。
        <br />
        <br />
        <van-col span="24" style="text-align: center">
          <van-button type="primary" @click="handleConfirm">我接受此声明</van-button>
        </van-col>
      </van-col>
    </van-popup>
  </div>
</template>

<script>
import MyCompany from '../commons/my-company'
import ChangeYm from '../commons/change-ym'
export default {
  components: { MyCompany, ChangeYm },
  data() {
    return {
      folderIcon: require('@/assets/folder.png'),
      showDate: false,
      ym: this.$store.getters.currYm,
      showTip: true,

    }
  },
  methods: {
    onYmChange(show, ym) {
      this.showDate = show
      if (ym) {
        this.ym = ym
      }
    },
        handleConfirm() {
      this.showTip = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/files.vue